/* Aimer Joias — Sobre Nós. Sem dependências; cada recurso isolado em try/catch para um erro não derrubar os outros. */
(function () {
  'use strict';
  var root = document.querySelector('.aso');
  if (!root) return;
  root.classList.add('aso-js');
  var reduz = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var temIO = 'IntersectionObserver' in window;
  var robo = /bot|crawl|spider|slurp|lighthouse|headless|preview/i.test(navigator.userAgent || '');

  function tenta(nome, fn) { try { fn(); } catch (e) { if (window.console) console.warn('[aimer-sobre] ' + nome, e); } }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  /* ---------- entradas ---------- */
  tenta('reveal', function () {
    var alvos = $$('[data-aso-reveal], .aso-paleta, .aso-camadas');
    $$('.aso-draw').forEach(function (p) { var s = p.closest('svg'); if (s && alvos.indexOf(s) < 0) alvos.push(s); });
    if (!temIO || reduz) { alvos.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    alvos.forEach(function (el) { io.observe(el); });
    // garantia: se algo ficou fora (ex.: impressão, âncora direta), mostra tudo após 6 s
    setTimeout(function () { alvos.forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in'); }); }, 6000);
  });

  /* ---------- contadores ---------- */
  tenta('contadores', function () {
    var nums = $$('[data-aso-count]');
    function anima(el) {
      var alvo = el.getAttribute('data-aso-count');
      var m = alvo.match(/^(\D*)(\d+)(\D*)$/);
      if (!m || reduz || robo) return;
      var fim = parseInt(m[2], 10), ini = fim > 1000 ? fim - 12 : 0, t0 = null, dur = 1400;
      function passo(t) {
        if (!t0) t0 = t;
        var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3);
        el.textContent = m[1] + Math.round(ini + (fim - ini) * e) + m[3];
        if (k < 1) requestAnimationFrame(passo);
      }
      requestAnimationFrame(passo);
    }
    if (!temIO) return;
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) { if (e.isIntersecting) { anima(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.6 });
    nums.forEach(function (n) { io.observe(n); });
  });

  /* ---------- fio da linha do tempo ---------- */
  tenta('fio', function () {
    var linha = root.querySelector('[data-aso-linha]');
    var fio = root.querySelector('[data-aso-fio]');
    if (!linha || !fio) return;
    if (reduz) { fio.style.setProperty('--p', 1); return; }
    var pend = false;
    function atualiza() {
      pend = false;
      var r = linha.getBoundingClientRect(), vh = window.innerHeight;
      var p = (vh * 0.62 - r.top) / Math.max(1, r.height);
      fio.style.setProperty('--p', Math.max(0, Math.min(1, p)).toFixed(4));
    }
    window.addEventListener('scroll', function () { if (!pend) { pend = true; requestAnimationFrame(atualiza); } }, { passive: true });
    window.addEventListener('resize', atualiza);
    atualiza();
  });

  /* ---------- filme do topo ---------- */
  tenta('filme', function () {
    var v = root.querySelector('[data-aso-hero-video]');
    var b = root.querySelector('[data-aso-toggle-video]');
    if (!v) return;
    var pausadoPeloUsuario = false;
    function marca(pausado) {
      if (!b) return;
      b.setAttribute('aria-pressed', pausado ? 'true' : 'false');
      b.setAttribute('aria-label', pausado ? 'Tocar o filme' : 'Pausar o filme');
    }
    if (reduz) { v.removeAttribute('autoplay'); v.pause(); pausadoPeloUsuario = true; marca(true); }
    if (b) b.addEventListener('click', function () {
      if (v.paused) { pausadoPeloUsuario = false; var p = v.play(); if (p && p.catch) p.catch(function () {}); marca(false); }
      else { pausadoPeloUsuario = true; v.pause(); marca(true); }
    });
    if (temIO) {
      new IntersectionObserver(function (ents) {
        ents.forEach(function (e) {
          if (e.isIntersecting) { if (!pausadoPeloUsuario) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
          else v.pause();
        });
      }, { threshold: 0.2 }).observe(v);
    }
  });

  /* ---------- reels: carregam perto da tela e tocam só quando visíveis ---------- */
  tenta('reels', function () {
    var vids = $$('[data-aso-reel]');
    if (!vids.length) return;
    function carrega(v) {
      if (v.dataset.carregado) return;
      $$('source[data-src]', v).forEach(function (s) { s.src = s.getAttribute('data-src'); s.removeAttribute('data-src'); });
      v.load(); v.dataset.carregado = '1';
    }
    if (!temIO) { vids.forEach(carrega); return; }
    var perto = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) { if (e.isIntersecting) { carrega(e.target); perto.unobserve(e.target); } });
    }, { rootMargin: '300px 300px' });
    var visivel = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && e.intersectionRatio >= 0.5 && !reduz) { carrega(v); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: [0, 0.5, 1] });
    vids.forEach(function (v) { perto.observe(v); visivel.observe(v); });
  });

  /* ---------- 7 camadas: ouro x ródio negro ---------- */
  tenta('camadas', function () {
    var box = root.querySelector('[data-aso-camadas]');
    if (!box) return;
    var bts = $$('[data-aso-acab]', box);
    bts.forEach(function (bt) {
      bt.addEventListener('click', function () {
        var rodio = bt.getAttribute('data-aso-acab') === 'rodio';
        box.classList.toggle('is-rodio', rodio);
        bts.forEach(function (o) { var on = o === bt; o.classList.toggle('is-on', on); o.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      });
    });
  });

  /* ---------- carrossel das coleções ---------- */
  tenta('slider', function () {
    var sl = root.querySelector('[data-aso-slider]');
    if (!sl) return;
    $$('[data-aso-slide]').forEach(function (b) {
      b.addEventListener('click', function () {
        var card = sl.querySelector('.aso-col');
        var passo = card ? (card.getBoundingClientRect().width + 20) * 2 : 600;
        sl.scrollBy({ left: passo * parseInt(b.getAttribute('data-aso-slide'), 10), behavior: reduz ? 'auto' : 'smooth' });
      });
    });
  });

  /* ---------- mapa: recorte retrato no celular ---------- */
  tenta('mapa', function () {
    var m = root.querySelector('.aso-mapa__svg');
    if (!m || !window.matchMedia) return;
    var mq = window.matchMedia('(max-width: 749px)');
    function aplica() { m.setAttribute('viewBox', mq.matches ? m.getAttribute('data-vb-m') : m.getAttribute('data-vb')); }
    aplica();
    if (mq.addEventListener) mq.addEventListener('change', aplica); else if (mq.addListener) mq.addListener(aplica);
  });

  /* ---------- perguntas: uma aberta por vez ---------- */
  tenta('faq', function () {
    var faq = root.querySelector('[data-aso-faq]');
    if (!faq) return;
    faq.addEventListener('toggle', function (e) {
      if (e.target.open) $$('details[open]', faq).forEach(function (d) { if (d !== e.target) d.open = false; });
    }, true);
  });

  /* ---------- loja aberta agora? (horário de Curitiba) ---------- */
  tenta('status', function () {
    var el = root.querySelector('[data-aso-status]');
    var txt = root.querySelector('[data-aso-status-txt]');
    if (!el || !txt || !window.Intl) return;
    var fmt = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Sao_Paulo', weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false });
    var dias = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    function horario(d) { return d === 0 ? [14, 20] : [10, 22]; }
    function atualiza() {
      var partes = {};
      fmt.formatToParts(new Date()).forEach(function (p) { partes[p.type] = p.value; });
      var d = dias[partes.weekday], h = parseInt(partes.hour, 10) % 24 + parseInt(partes.minute, 10) / 60;
      var hj = horario(d), aberta = h >= hj[0] && h < hj[1];
      el.classList.toggle('is-aberta', aberta);
      el.classList.toggle('is-fechada', !aberta);
      if (aberta) txt.textContent = 'Aberta agora · até ' + hj[1] + 'h';
      else if (h < hj[0]) txt.textContent = 'Fechada agora · abre hoje às ' + hj[0] + 'h';
      else txt.textContent = 'Fechada agora · abre amanhã às ' + horario((d + 1) % 7)[0] + 'h';
    }
    atualiza();
    setInterval(atualiza, 60000);
  });
})();
